import { Grid2 } from "@mui/material";

const styles = {
    errorBox: {
      backgroundColor: '#f8d7da',
      color: '#721c24',
      border: '1px solid #f5c6cb',
      paddingLeft: '4%',
      paddingRight: '4%',
      borderRadius: '5px',
    //   textAlign: 'center',
      border: '1px solid #721c24',
      margin: '8px'
    }
};

const TokenError = () => {
    return (

        <Grid2 sx={{justifyItems:'right'}}>
            <div style={styles.errorBox}>
                <p>Session Expired. Please Login Again.</p>
            </div>
        </Grid2>
        
    )
};

export default TokenError;
   